module.exports = __webpack_public_path__ + "fonts/0bea0520760bfb0e010a58bf0da1c0fe.txt";